const SET_ADDED_ELEMENT = 'SET_ADDED_ELEMENT';

export default {
	namespaced: true,
	state: {
		addedElement: null
	},
	actions: {
		setAddedElement({commit}, webitem) {
			commit(SET_ADDED_ELEMENT, webitem);
		}
	},
	mutations: {
		[SET_ADDED_ELEMENT](state, webitem) {
			state.addedElement = webitem;
		}
	}
};



// WEBPACK FOOTER //
// ../source/modules/MDL08-new-item-in-cart/MDL08-new-item-in-cart-vuex.js